var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"brand-logo"},[_c('img',{attrs:{"src":_vm.appLogoUrl,"alt":"logo"}}),_c('h2',{staticClass:"brand-text text-primary ml-1 mt-1"},[_vm._v(" "+_vm._s(_vm.appTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }